import styled from 'styled-components';
import colors from '../../../../../helpers/colors';
import fonts from '../../../../../helpers/fonts';
import spacing from '../../../../../helpers/spacing';
import { ButtonLink } from '../../../../Link';
import RichText from '../../../../RichText';

export const ToggleTooltipButton = styled(ButtonLink)`
  ${fonts.paragraph}
  & {
    color: ${colors.core01};
    font-weight: normal;
  }
  text-decoration: underline;
  vertical-align: middle;
  display: inline;
`;

const tooltipArrowHeight = '7px';

export const TooltipWrapper = styled.div`
  padding: calc(${spacing(1)} + ${tooltipArrowHeight}) 0 ${spacing(1)};
`;

export const TooltipBody = styled(RichText)`
  ${fonts.paragraph}

  background-color: ${colors.neutral06};
  border-radius: ${({ theme }) => `${theme.cardRadius}`};
  border: 1px ${colors.cardBorder} solid;
  padding: ${spacing(2)};
  position: relative;

  & > :first-child {
    margin-top: 0;
  }

  &::before {
    position: absolute;
    content: '';
    display: block;
    background-color: ${colors.neutral06};
    border: ${colors.cardBorder} solid;
    border-width: 1px 0 0 1px;

    width: 12px;
    height: 12px;
    top: -${tooltipArrowHeight};
    transform: rotate(45deg);
  }
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing(1)};
`;
